/**
 * Social Sharing autohandler.
 *
 * Adding this auto handling here as a global attribute binding allows for
 * reusable component functionality across the entire site rather than
 * focused on a single page.
 *
 * Usage:
 *
 *  data-sw-social-share=<network>
 *
 * Example:
 *
 * <a href="http://url.to/open/when/clicked" data-sw-social-share="twitter">Click Me</a>
 */

var $ = require('./../sw-jquery');
var popup = require('./../../lib/popup');

$(document).ready(function() {
  
  $('body').on('click', '[data-sw-social-share]', function(e){
    var $this = $(this);
    e.preventDefault();
    popup({u: $this.attr('href')});
  });

  $('body').on('click', '[data-sw-embed-share]', function(){
    var $this = $(this);
    if($this.data('swEmbedShareTracked')){
      return;
    }
    $this.data('swEmbedShareTracked', 'true');
  });
});
